<div *ngIf="messages.size > 0" class="wrapper">
  <ul class="v-list">
    <li *ngFor="let message of messages; let i = index;">
      <span class="alert alert__{{message.type}}">
        <strong *ngIf="!!message.name">{{message.name}}: </strong>
        <span [innerHTML]="message.message"></span>
      </span>
    </li>
  </ul>
</div>